<template>
<div class="bodyclass">
<!--首页大框-->
<div class="top-box-ins"> 
  <!--菜单-->
  <div class="top-menu">
    <div class="top-menu-t clearfloat">
      <div class="menu-logo fl"></div>
      <div class="menu-txt fl">
        <ul class="li-div-txt">
          <li><a class="dbi fb w100 menu-atxt" href="/">首页</a></li>
          <li> <a class="dbi fb w100 menu-atxt" href="/chanping1">产品</a>
            <div class="li-div" style="width:1000px;">
              <div class="li-div-left fl"> <span class="tl dbi">产品</span> </div>
              <div class="w68 fl">
                <ul class="li-div-txt">
                  <li class="" style="width:23%"> 
                        <a class="dbi  w100 menu-atxt" href="/chanping4">
                          <div class="li-div-d2 mt10 "> 
                            <img src="../assets/images/z13-ytj.png" class="li-div-img">
                          </div>
                          <h1 class="f16 lh20 mt10 dbi">视觉智能体</h1>
                        </a> 
                      </li>
                      <li style="width:23%"> 
                        <a class="dbi w100 menu-atxt" href="/chanping3">
                          <div class="li-div-d2 mt10"> 
                            <img src="../assets/images/z12-ytj.png" class="li-div-img">
                          </div>
                          <h1 class="f16 lh20 mt10 dbi">新一代公共安全视觉智能体</h1>
                        </a> 
                      </li>
                  <li class="" style="width:23%"> <a class="dbi  w100 menu-atxt" href="/chanping1">
                    <div class="li-div-d2 mt10 "> <img src="../assets/images/z1-ytj.png"  class="li-div-img"></div>
                    <h1 class="f16 lh20 mt10 dbi">谛视万象多模态视觉大模型</h1>
                    </a> </li>
                  <li style="width:23%"> <a class="dbi  w100 menu-atxt" href="/chanping2" >
                    <div class="li-div-d2 mt10 "> <img src="../assets/images/z2-ytj.png"  class="li-div-img"></div>
                    <h1 class="f16 lh20 mt10 dbi">谛视万象多模态视觉大模型</h1>
                    </a> </li>
                </ul>
              </div>
            </div>
          </li>
          <li><a class="dbi fb w100 menu-atxt" href="/jiejfa1">解决方案</a>
            <div class="li-div" style="width:1300px;">
              <div class="li-div-left fl" style="width:220px" > <span class="tl dbi">解决方案</span> </div>
              <div class="w70 fl" style="height:148px;">
                <ul class="">
                  <li> <a class="dbi  w100 menu-atxt" href="/jiejfa1" >
                    <div class="li-div-d2 mt10 "> <img src="../assets/images/z3-ytj.png"  class="li-div-img"></div>
                    <h1 class="f16 lh40 ">公共安全行业解决方案</h1>
                    </a> </li>
                  <li> <a class="dbi  w100 menu-atxt" href="/yijii2">
                    <div class="li-div-d2 mt10 "> <img src="../assets/images/z4-ytj.png"  class="li-div-img"></div>
                    <h1 class="f16 lh40">应急行业解决方案</h1>
                    </a> </li>
                  <li> <a class="dbi  w100 menu-atxt" href="/chengguan3" >
                    <div class="li-div-d2 mt10 "> <img src="../assets/images/z5-ytj.png"  class="li-div-img"></div>
                    <h1 class="f16 lh40">城管行业解决方案</h1>
                    </a> </li>
                  <li> <a class="dbi  w100 menu-atxt" href="/jiaotong4" >
                    <div class="li-div-d2 mt10 "> <img src="../assets/images/z6-ytj.png"  class="li-div-img"></div>
                    <h1 class="f16 lh40">交通行业解决方案</h1>
                    </a> </li>
                  <li> <a class="dbi  w100 menu-atxt" href="/qiyeigl5" >
                    <div class="li-div-d2 mt10 "> <img src="../assets/images/z7-ytj.png"  class="li-div-img"></div>
                    <h1 class="f16 lh40">企业管理解决方案</h1>
                    </a> </li>
                </ul>
              </div>
            </div>
          </li>
          <li><a class="dbi fb w100 menu-atxt" href="/severHtml">服务&生态</a></li>
          <li><a class="dbi fb w100 menu-atxt" href="/gywmHtml">关于我们</a></li>
        </ul>
      </div>
    </div>
  </div>
  <!--菜单end--> 
  
  <!--背景图-->
  <div class="top-backgr">
    <div class="top-box-ins-img bgimg"  ></div>
    <div class="top-box-ins-imga1 bgimg2"  ></div>
  </div>
  <!--背景图end--> 
  
  <!--首页大框end--> 
</div>
<!--首页大框--> 
<!--内容大框-->
<div class="main pt84"> 
  
  <!--解决方案-->
  <div class="w100 lh40 tc WOW animate__animated animate__fadeInUp"> 
    <span class="db f48 fb lp2 mt40">新一代公共安全视觉智能体</span> 
    <span class="db f24  lp2 mt10 col-gr">Next-Generation Public Security Visual Intelligent Agent</span> 
</div>
  <div class="w80 jz mt40 lh30 f16">
    <p class="f20 fb mb30 tc WOW animate__animated animate__fadeInUp" style="animation-delay: 0.3s;">产品介绍</p>
    <p class="tl mb40 WOW animate__animated animate__fadeInUp" style="animation-delay: 0.3s;">以视觉大模型为核心感知中枢，为安防场景下机器人、机器狗、无人机、无人车、执法记录仪等具身智能设备构建 “小脑 + 大脑” 双重能力体系，赋能其成为具备自主安防感知与决策的智能体。方案通过视觉智能体为智能终端赋予媲美生物视觉的动态分析能力，使其既能依托 “小脑” 般的精准控制实现实时动作把控，又能凭借 “大脑” 般的深度逻辑决策支撑复杂场景研判 。 这种双重能力让智能体彻底突破传统 “指令 - 执行” 模式，在动态公共安全场景中实现 “感知即决策”，重新定义具身智能设备的自主协同边界，推动智能体从被动响应向主动交互、自主协同的高阶形态演进。</p>
    <p class="f20 fb mb30 tc WOW animate__animated animate__fadeInUp" style="animation-delay: 0.5s;">产品能力</p>
    <p class="f16 fb  tl WOW animate__animated animate__fadeInUp" style="animation-delay: 0.5s;color:rgb(255,0,0);" >语音调度指挥行动</p>
    <p class="tl WOW animate__animated animate__fadeInUp" style="animation-delay: 0.5s;">支持以语音交互的方式指挥智能终端设备载体行动，可动态创建专属命令，驱动智能体主动开展环境洞察任务 ，智能体能基于命令快速启动视觉感知与数据解析，实时识别指定物体、捕捉物体行为、感知环境变化。</p>
    <p class="f16 fb mt20 tl WOW animate__animated animate__fadeInUp" style="animation-delay: 0.7s;color:rgb(255,0,0);">智能定义自动巡逻</p>
    <p class="tl WOW animate__animated animate__fadeInUp" style="animation-delay: 0.5s;">支持智能终端（无人车、机器人等）自助规划巡逻路线，并以全自动方式完成指定区域内的巡逻任务，终端搭载的视觉智能体能精准识别并捕捉区域内的异常入侵、物品异动、人员违规滞留等安防事件，实现全天候智能值守</p>
    <p class="f16 fb mt20 tl WOW animate__animated animate__fadeInUp" style="animation-delay: 0.7s;color:rgb(255,0,0);">动态场景自主适应</p>
    <p class="tl WOW animate__animated animate__fadeInUp" style="animation-delay: 0.5s;">面对动态变化的复杂场景，大幅降低智能体因 “场景变化导致的系统失效成本”。通过打通 “感知 - 计算 - 执行” 全链路协同，从 “固定场景专用” 升级为 “多场景自适应”, 驱动智能体快速适配环境变量。</p>
    <p class="f20 fb mb30 tc WOW animate__animated animate__fadeInUp" style="animation-delay: 0.5s;">产品优势</p>
    <img src="../assets/images/ggaq_cpys.png" style="width:90%; margin:0 5%">
    <p class="f20 fb mb30 tc WOW animate__animated animate__fadeInUp" style="animation-delay: 0.5s;">产品说明</p>
    <img src="../assets/images/ggaq_jgt.png" style="width:90%; margin:0 5%">
    <p class="f20 fb mb30 tc WOW animate__animated animate__fadeInUp" style="animation-delay: 0.5s;">典型场景</p>
    <img src="../assets/images/ggaq_dxcj1.png" style="width:90%; margin:0 5%">
    <img src="../assets/images/ggaq_dxcj2.png" style="width:90%; margin:0 5%">
    
  </div>
  <!--解决方案end--> 
</div>
<!--内容大框end--> 
<!--底宣-->
<div class="btto-a1 mt100 ov">
      <div class="btto-a2 jz mt30">
        <ul class="w100 he68">
          <li class="fl WOW animate__animated animate__fadeInRight animate__duration-5s" style="animation-delay: 0.1s;">
            <div class="btt-ico fl ">
              <img src="../assets/images/za1-ytj.png" width="68" height="68" alt="" />
            </div>
            <div class="fl ml10">
              <div class="mt10">
                <span class="dbi col-gr2 f18 fb lp1">全场景算法</span>
                <span class="dbi col-gr3 f14  lp1 abcd mt4 ml6">algorithm</span>
              </div>
              <div class="mt4 col-gr3">多种行业全场景算法</div>
            </div>
          </li>
          <li class="fl WOW animate__animated animate__fadeInRight animate__duration-5s" style="animation-delay: 0.3s;">
            <div class="btt-ico fl">
              <img src="../assets/images/za2-ytj.png" width="68" height="68" alt="" />
            </div>
            <div class="fl ml10">
              <div class="mt10">
                <span class="dbi col-gr2 f18 fb lp1">算法灵活自定义</span>
                <span class="dbi col-gr3 f14  lp1 abcd mt4 ml6">Custom</span>
              </div>
              <div class="mt4 col-gr3">可通过文字自定义描述方式新增修改</div>
            </div>
          </li>
          <li class="fl WOW animate__animated animate__fadeInRight animate__duration-5s" style="animation-delay: 0.5s;">
            <div class="btt-ico fl">
              <img src="../assets/images/za3-ytj.png" width="68" height="68" alt="" />
            </div>
            <div class="fl ml10">
              <div class="mt10">
                <span class="dbi col-gr2 f18 fb lp1">国产化生态支持</span>
                <span class="dbi col-gr3 f14  lp1 abcd mt4 ml6">support</span>
              </div>
              <div class="mt4 col-gr3">基于自主可控的国产化IT底层架构</div>
            </div>
          </li>
          <li class="fl WOW animate__animated animate__fadeInRight animate__duration-5s" style="animation-delay: 0.7s;">
            <div class="btt-ico fl">
              <img src="../assets/images/za4-ytj.png" width="68" height="68" alt="" />
            </div>
            <div class="fl ml10">
              <div class="mt10">
                <span class="dbi col-gr2 f18 fb lp1">完善标准化</span>
                <span class="dbi col-gr3 f14  lp1 abcd mt4 ml6">standardization</span>
              </div>
              <div class="mt4 col-gr3">支持主流音视频标准化协议</div>
            </div>
          </li>
          <li class="fl WOW animate__animated animate__fadeInRight animate__duration-5s" style="animation-delay: 0.9s;">
            <div class="btt-ico fl">
              <img src="../assets/images/za5-ytj.png" width="68" height="68" alt="" />
            </div>
            <div class="fl ml10">
              <div class="mt10">
                <span class="dbi col-gr2 f18 fb lp1">大模型技术</span>
                <span class="dbi col-gr3 f14  lp1 abcd mt4 ml6">Large Model</span>
              </div>
              <div class="mt4 col-gr3">使用Transformer架构</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
<!--底宣end--> 
 <!--底宣2-->
    <div class="btto-b-a1 ov">
      <div class="mt30 w100 jz dbi">
        <div class="tc WOW animate__animated animate__fadeInRight animate__duration-5s" style="animation-delay: 0.1s;"> <img src="../assets/images/ying-28.jpg" width="76" height="76" alt="" class="  dbi " /></div>
        <ul class="w100 he92 tc mt20">
          <li class=" WOW animate__animated animate__fadeInRight animate__duration-5s dbi" style="animation-delay: 0.1s;">
            <div class="tl f24 white he35 fl">上海谛视万象科技有限公司</div>
            <div class="ov  fl ml30">
              <span class="dbi btto-b-sp fl">
                <img src="../assets/images/ico2_3.png" width="38" height="38" alt="" />
              </span>
              <span class="dbi fl ml10 mt10 f14 col-gr3">联系电话：4007628008</span>
            </div>
          <!--  <div class="ov fl ml30">
              <span class="dbi btto-b-sp fl">
                <img src="../assets/images/ico2_1.png" width="38" height="38" alt="" />
              </span>
              <span class="dbi fl ml10 mt10 f14 col-gr3">地址：上海市普陀区真北路2653号天地科技园</span>
            </div>-->
          </li>
                   
        </ul>
      </div>
    </div>
    <!--底宣2end--> 
<!--底宣3-->
<div class="he90 tc btto-c"><span class="dbi col-gr3  mt30 mr40">辽ICP备2025061615号</span> <span class="dbi col-gr3  mt30">Copyright © 2004 - 2025 谛视万象版权所有</span></div>
<!--底宣3end-->
</div>
</template>
<script setup>
// , onUpdated, onUnmounted, ref
import { onMounted } from 'vue';
import * as WOW from 'wowjs';
// let wowInstance = null;
onMounted(() => {
    new WOW.WOW({
        // boxClass: 'wow',
        animateClass: 'animate__animated',
        offset: 50,       // 元素进入视口 100px 后触发
        // mobile: true,      // 移动端启用
        live: true,        // 监听动态添加的元素
    }).init();
})
</script>
<style scoped>
@import '@/assets/css/default.css';
@import '@/assets/css/font-awesome.min.css';
@import '@/assets/css/margin.css';
@import '@/assets/css/main.css';

/* style="background:url(../assets/images/bana-9.jpg) center center no-repeat;background-size:cover;" */
/* style="background:url(../assets/images/z8-ytj.png) center center no-repeat;background-size:cover;" */
.bgimg{
    background:url(../assets/images/bana-9.jpg) center center no-repeat;
    background-size:cover;
}

.bgimg2{
    background:url(../assets/images/z8-ytj.png) center center no-repeat;
    background-size:cover;
}

.animate__animated {
  animation-duration: 2s !important;
}

</style>